<main role="main" class="flex h-screen p-4 overflow-x-hidden public-page">
  <div class="m-auto mb-0 w-full max-w-[100%] md:max-w-[500px] flex flex-col">
    <div class="flex w-full items-center gap-2 mb-2 sm:mb-4">
      <app-back-button [url]="'/'" />
      <h1
        class="truncate pr-9 text-3xl max-w-full whitespace-nowrap overflow-hidden lg:text-5xl lg:leading-[120%]"
        id="registerFormHeading"
      >
        {{ isSuccesfull ? 'Registratie succesvol' : 'Creëer een account' }}
      </h1>
    </div>
    @if (!isSuccesfull) {
      <form
        [formGroup]="registerForm"
        (ngSubmit)="onRegister()"
        role="form"
        aria-labelledby="registerFormHeading"
        [attr.aria-busy]="isLoading"
        class="flex-1"
      >
        <app-card class="block w-full mt-2 mb-9">
          @if (registerError) {
            <p class="text-red-500 text-center mb-4" role="alert">
              {{ registerError }}
            </p>
          }
          <div class="custom-input-container mt-4 w-full">
            <label class="custom-label" for="username">Gebruikersnaam</label>
            <mat-form-field appearance="outline">
              <input
                id="username"
                matInput
                type="email"
                formControlName="username"
                placeholder="Geef een gebruikersnaam op"
                autocomplete="username"
                aria-describedby="usernameError"
              />
              <mat-error id="usernameError" role="alert">Vul een geldige gebruikersnaam</mat-error>
            </mat-form-field>
          </div>
          <div class="custom-input-container w-full">
            <label class="custom-label" for="email">E-mailadres</label>
            <mat-form-field appearance="outline">
              <input
                id="email"
                matInput
                type="email"
                formControlName="email"
                placeholder="Geef een e-mailadres op"
                autocomplete="email"
                aria-describedby="emailError"
              />
              <mat-error id="emailError" role="alert">Vul een geldige email in.</mat-error>
            </mat-form-field>
          </div>
          <div class="custom-input-container w-full custom-input-container--password">
            <label class="custom-label" for="password">Wachtwoord</label>
            <mat-form-field appearance="outline">
              <input
                id="password"
                matInput
                type="password"
                formControlName="password"
                placeholder="Creëer een wachtwoord"
                autocomplete="current-password"
                aria-describedby="passwordError"
              />
              <app-password-toggle matSuffix [for]="'password'"></app-password-toggle>
              <mat-error id="passwordError" role="alert">Wachtwoord voldoet niet.</mat-error>
            </mat-form-field>
          </div>

          <div class="custom-input-container w-full">
            <label id="educatorLabel" class="custom-label" for="educator">Opleider</label>
            <mat-form-field appearance="outline">
              <mat-select
                id="educator"
                data-testid="educator-select"
                formControlName="educatorId"
                (selectionChange)="onEducatorSelected()"
                placeholder="Selecteer een opleider"
                required
                aria-labelledby="educatorLabel"
                [attr.aria-invalid]="
                  registerForm.controls.educatorId.invalid &&
                  (registerForm.controls.educatorId.touched || registrationSubmitted())
                "
                [aria-describedby]="
                  registrationEducatorsState().isLoading ||
                  registrationEducatorsState().error ||
                  registrationEducatorsState().educators.length === 0
                    ? 'educatorLoadStatus'
                    : ''
                "
              >
                @for (educator of registrationEducatorsState().educators; track educator.id) {
                  <mat-option [value]="educator.id">{{ educator.name }}</mat-option>
                }
              </mat-select>
              <mat-error id="educatorError" role="alert">Selecteer een opleider.</mat-error>
            </mat-form-field>
            @if (registrationEducatorsState().isLoading) {
              <p id="educatorLoadStatus" role="status">Opleiders worden geladen...</p>
            } @else if (registrationEducatorsState().error) {
              <p id="educatorLoadStatus" role="alert" class="text-error-800 mb-4">
                {{ registrationEducatorsState().error }}
              </p>
              <button mat-stroked-button color="primary" type="button" (click)="retryRegistrationEducators()">
                Opnieuw proberen
              </button>
            } @else if (registrationEducatorsState().educators.length === 0) {
              <p id="educatorLoadStatus" role="alert" class="text-error-800 mb-4">
                Er zijn momenteel geen opleiders beschikbaar. Registreren is daarom niet mogelijk.
              </p>
            }
          </div>

          <div class="flex flex-col gap-3" role="list" aria-label="Wachtwoord vereisten">
            <div class="flex items-center gap-2" role="listitem">
              <span
                class="!w-[22px] !h-[22px] rounded-full bg-[#8C8C8C] flex items-center justify-center"
                [ngClass]="
                  this.registerForm.value.password && this.registerForm.value.password.length >= 6
                    ? 'bg-success'
                    : 'bg-[#8C8C8C]'
                "
              >
                <mat-icon class="text-sm text-white" aria-label="Melding sluiten"> check </mat-icon>
              </span>
              <span class="text-sm"> Bevat minimaal 6 karakters </span>
            </div>
            <div class="flex items-center gap-2" role="listitem">
              <span
                class="!w-[22px] !h-[22px] rounded-full bg-[#8C8C8C] flex items-center justify-center"
                [ngClass]="hasUppercase ? 'bg-success' : 'bg-[#8C8C8C]'"
              >
                <mat-icon class="text-sm text-white" [attr.aria-label]="hasUppercase ? 'Voldoet' : 'Voldoet niet'">
                  check
                </mat-icon>
              </span>
              <span class="text-sm">Bevat minimaal 1 hoofdletter </span>
            </div>
            <div class="flex items-center gap-2" role="listitem">
              <span
                class="!w-[22px] !h-[22px] rounded-full bg-[#8C8C8C] flex items-center justify-center"
                [ngClass]="hasNumber ? 'bg-success' : 'bg-[#8C8C8C]'"
              >
                <mat-icon
                  class="text-sm text-white"
                  aria-label="Melding sluiten"
                  [attr.aria-label]="hasNumber ? 'Voldoet' : 'Voldoet niet'"
                >
                  check
                </mat-icon>
              </span>
              <span class="text-sm">Bevat minimaal 1 cijfer</span>
            </div>
            <div class="flex items-center gap-2" role="listitem">
              <span
                class="!w-[22px] !h-[22px] rounded-full bg-[#8C8C8C] flex items-center justify-center"
                [ngClass]="hasSpecialChar ? 'bg-success' : 'bg-[#8C8C8C]'"
              >
                <mat-icon class="text-sm text-white" [attr.aria-label]="hasSpecialChar ? 'Voldoet' : 'Voldoet niet'">
                  check
                </mat-icon>
              </span>
              <span class="text-sm">Bevat minimaal 1 speciale karakter</span>
            </div>
          </div>
        </app-card>
        <div class="flex justify-end mb-4">
          <button
            mat-flat-button
            color="accent"
            type="submit"
            [disabled]="registerForm.invalid || isLoading || !canRegister()"
            class="w-full button-large"
          >
            {{ isLoading ? 'Account wordt aangemaakt…' : 'Creëer account' }}
          </button>
          <p class="sr-only" role="status" aria-live="polite">
            {{ isLoading ? 'Account wordt aangemaakt…' : '' }}
          </p>
        </div>

        <div class="text-center sm:text-end text-base mb-0 sm:mb-8">
          Heb je al een account? <a routerLink="/login" class="font-semibold text-primary-500">Login </a>
        </div>
        <div class="mt-2 sm:mt-4">
          <app-logo-images></app-logo-images>
        </div>
      </form>
    } @else {
      <app-card class="block w-full mt-6 mb-9">
        <p class="mb-4" role="alert">
          Er is een e-mail verstuurd naar je e-mailadres met een link om je account te activeren!
        </p>
      </app-card>
      <a mat-flat-button color="accent" class="" routerLink="/login" class="w-full button-large">Naar inloggen </a>

      <div class="mt-2 sm:mt-4">
        <app-logo-images></app-logo-images>
      </div>
    }
  </div>
</main>
